var s = [];

function getHijriYearArray(g_date) {
    var g = g_date;
    switch (true) {
        /* تقويم أم القرى - صادرة من مدينة الملك عبدالعزيز للعلوم والتقنية معهد بحوث الحاسب والإلكترونيات بجدة*/
        case(g >= 19990417 && g < 20000406):
            s = [19990417, 1420, 0, 1, 0, 0, 1, 0, 1, 1, 1, 1, 0, 1];
            break;
        case(g >= 20000406 && g < 20010326):
            s = [20000406, 1421, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1, 0, 1];
            break;
        case(g >= 20010326 && g < 20020315):
            s = [20010326, 1422, 1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 0, 1];
            break;
        case(g >= 20020315 && g < 20030304):
            s = [20020315, 1423, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20030304 && g < 20040221):
            s = [20030304, 1424, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 20040221 && g < 20050210):
            s = [20040221, 1425, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0];
            break;
        case(g >= 20050210 && g < 20060131):
            s = [20050210, 1426, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 20060131 && g < 20070120):
            s = [20060131, 1427, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 20070120 && g < 20080110):
            s = [20070120, 1428, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 1, 1];
            break;
        case(g >= 20080110 && g < 20081229):
            s = [20080110, 1429, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 20081229 && g < 20091218):
            s = [20081229, 1430, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20091218 && g < 20101207):
            s = [20091218, 1431, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 20101207 && g < 20111126):
            s = [20101207, 1432, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 20111126 && g < 20121115):
            s = [20111126, 1433, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 20121115 && g < 20131104):
            s = [20121115, 1434, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 0];
            break;
        case(g >= 20131104 && g < 20141025):
            s = [20131104, 1435, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 20141025 && g < 20151014):
            s = [20141025, 1436, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20151014 && g < 20161002):
            s = [20151014, 1437, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 20161002 && g < 20170921):
            s = [20161002, 1438, 1, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 20170921 && g < 20180911):
            s = [20170921, 1439, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 20180911 && g < 20190831):
            s = [20180911, 1440, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 20190831 && g < 20200820):
            s = [20190831, 1441, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0];
            break;
        case(g >= 20200820 && g < 20210809):
            s = [20200820, 1442, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0];
            break;
        case(g >= 20210809 && g < 20220730):
            s = [20210809, 1443, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 20220730 && g < 20230719):
            s = [20220730, 1444, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20230719 && g < 20240707):
            s = [20230719, 1445, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1];
            break;
        case(g >= 20240707 && g < 20250626):
            s = [20240707, 1446, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0];
            break;
        case(g >= 20250626 && g < 20260616):
            s = [20250626, 1447, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 20260616 && g < 20270606):
            s = [20260616, 1448, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1];
            break;
        case(g >= 20270606 && g < 20280525):
            s = [20270606, 1449, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 20280525 && g < 20290514):
            s = [20280525, 1450, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0];
            break;
        /*السنوات من 1451 حتى 1500 من تقويم أبو هادي الفلكي حسب مكة المكرمةوقد تحتوي على اختلافات ضئيلة قد تصل إلى خمسة شهور من أصل ستمائة شهر*/
        case(g >= 20290514 && g < 20300504):
            s = [20290514, 1451, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 20300504 && g < 20310423):
            s = [20300504, 1452, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20310423 && g < 20320411):
            s = [20310423, 1453, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 20320411 && g < 20330401):
            s = [20320411, 1454, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20330401 && g < 20340321):
            s = [20330401, 1455, 0, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0];
            break;
        case(g >= 20340321 && g < 20350311):
            s = [20340321, 1456, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1];
            break;
        case(g >= 20350311 && g < 20360228):
            s = [20350311, 1457, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 20360228 && g < 20370216):
            s = [20360228, 1458, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1];
            break;
        case(g >= 20370216 && g < 20380205):
            s = [20370216, 1459, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0];
            break;
        case(g >= 20380205 && g < 20390126):
            s = [20380205, 1460, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1];
            break;
        case(g >= 20390126 && g < 20400115):
            s = [20390126, 1461, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 20400115 && g < 20410104):
            s = [20400115, 1462, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 20410104 && g < 20411224):
            s = [20410104, 1463, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 20411224 && g < 20421214):
            s = [20411224, 1464, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1];
            break;
        case(g >= 20421214 && g < 20431203):
            s = [20421214, 1465, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 1];
            break;
        case(g >= 20431203 && g < 20441121):
            s = [20431203, 1466, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20441121 && g < 20451110):
            s = [20441121, 1467, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 20451110 && g < 20461031):
            s = [20451110, 1468, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20461031 && g < 20471020):
            s = [20461031, 1469, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0];
            break;
        case(g >= 20471020 && g < 20481009):
            s = [20471020, 1470, 1, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1, 0];
            break;
        case(g >= 20481009 && g < 20490928):
            s = [20481009, 1471, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 20490928 && g < 20500917):
            s = [20490928, 1472, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0];
            break;
        case(g >= 20500917 && g < 20510906):
            s = [20500917, 1473, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 20510906 && g < 20520826):
            s = [20510906, 1474, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 20520826 && g < 20530815):
            s = [20520826, 1475, 0, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 20530815 && g < 20540805):
            s = [20530815, 1476, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1];
            break;
        case(g >= 20540805 && g < 20550725):
            s = [20540805, 1477, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 0];
            break;
        case(g >= 20550725 && g < 20560714):
            s = [20550725, 1478, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 20560714 && g < 20570703):
            s = [20560714, 1479, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 20570703 && g < 20580622):
            s = [20570703, 1480, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20580622 && g < 20590611):
            s = [20580622, 1481, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 20590611 && g < 20600531):
            s = [20590611, 1482, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 20600531 && g < 20610520):
            s = [20600531, 1483, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0];
            break;
        case(g >= 20610520 && g < 20620510):
            s = [20610520, 1484, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 20620510 && g < 20630430):
            s = [20620510, 1485, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1];
            break;
        case(g >= 20630430 && g < 20640418):
            s = [20630430, 1486, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 20640418 && g < 20650407):
            s = [20640418, 1487, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1];
            break;
        case(g >= 20650407 && g < 20660327):
            s = [20650407, 1488, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 20660327 && g < 20670317):
            s = [20660327, 1489, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 1];
            break;
        case(g >= 20670317 && g < 20680305):
            s = [20670317, 1490, 0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 20680305 && g < 20690223):
            s = [20680305, 1491, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 20690223 && g < 20700212):
            s = [20690223, 1492, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 20700212 && g < 20710201):
            s = [20700212, 1493, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1];
            break;
        case(g >= 20710201 && g < 20720121):
            s = [20710201, 1494, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20720121 && g < 20730109):
            s = [20720121, 1495, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 20730109 && g < 20731230):
            s = [20730109, 1496, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 20731230 && g < 20741219):
            s = [20731230, 1497, 0, 1, 0, 1, 1, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 20741219 && g < 20751209):
            s = [20741219, 1498, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 20751209 && g < 20761127):
            s = [20751209, 1499, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0];
            break;
        /* تقويم أم القرى المقارن - صادر من وزارة المالية والاقتصاد الوطني  تنفيذ وطبع  مصلحة مطابع الحكومة - الرياض 1413هـ*/
        case(g >= 18821111 && g < 18831031):
            s = [18821111, 1300, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 18831031 && g < 18841020):
            s = [18831031, 1301, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1];
            break;
        case(g >= 18841020 && g < 18851009):
            s = [18841020, 1302, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1];
            break;
        case(g >= 18851009 && g < 18860928):
            s = [18851009, 1303, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0];
            break;
        case(g >= 18860928 && g < 18870918):
            s = [18860928, 1304, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 18870918 && g < 18880907):
            s = [18870918, 1305, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1];
            break;
        case(g >= 18880907 && g < 18890827):
            s = [18880907, 1306, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 18890827 && g < 18900816):
            s = [18890827, 1307, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0];
            break;
        case(g >= 18900816 && g < 18910805):
            s = [18900816, 1308, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 18910805 && g < 18920724):
            s = [18910805, 1309, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0];
            break;
        case(g >= 18920724 && g < 18930714):
            s = [18920724, 1310, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 18930714 && g < 18940704):
            s = [18930714, 1311, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1];
            break;
        case(g >= 18940704 && g < 18950623):
            s = [18940704, 1312, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 0];
            break;
        case(g >= 18950623 && g < 18960612):
            s = [18950623, 1313, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1];
            break;
        case(g >= 18960612 && g < 18970601):
            s = [18960612, 1314, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 18970601 && g < 18980521):
            s = [18970601, 1315, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 18980521 && g < 18990510):
            s = [18980521, 1316, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 18990510 && g < 19000430):
            s = [18990510, 1317, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 19000430 && g < 19010419):
            s = [19000430, 1318, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 0];
            break;
        case(g >= 19010419 && g < 19020409):
            s = [19010419, 1319, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 19020409 && g < 19030330):
            s = [19020409, 1320, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1];
            break;
        case(g >= 19030330 && g < 19040318):
            s = [19030330, 1321, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1];
            break;
        case(g >= 19040318 && g < 19050307):
            s = [19040318, 1322, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 19050307 && g < 19060224):
            s = [19050307, 1323, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19060224 && g < 19070213):
            s = [19060224, 1324, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 19070213 && g < 19080203):
            s = [19070213, 1325, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19080203 && g < 19090123):
            s = [19080203, 1326, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 19090123 && g < 19100112):
            s = [19090123, 1327, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1];
            break;
        case(g >= 19100112 && g < 19110101):
            s = [19100112, 1328, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 19110101 && g < 19111221):
            s = [19110101, 1329, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19111221 && g < 19121209):
            s = [19111221, 1330, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 19121209 && g < 19131129):
            s = [19121209, 1331, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19131129 && g < 19141118):
            s = [19131129, 1332, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 19141118 && g < 19151108):
            s = [19141118, 1333, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19151108 && g < 19161027):
            s = [19151108, 1334, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0];
            break;
        case(g >= 19161027 && g < 19171017):
            s = [19161027, 1335, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 19171017 && g < 19181006):
            s = [19171017, 1336, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1];
            break;
        case(g >= 19181006 && g < 19190925):
            s = [19181006, 1337, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19190925 && g < 19200913):
            s = [19190925, 1338, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 19200913 && g < 19210903):
            s = [19200913, 1339, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 19210903 && g < 19220823):
            s = [19210903, 1340, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0];
            break;
        case(g >= 19220823 && g < 19230813):
            s = [19220823, 1341, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 19230813 && g < 19240801):
            s = [19230813, 1342, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0];
            break;
        case(g >= 19240801 && g < 19250721):
            s = [19240801, 1343, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19250721 && g < 19260710):
            s = [19250721, 1344, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 19260710 && g < 19270630):
            s = [19260710, 1345, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 19270630 && g < 19280618):
            s = [19270630, 1346, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 19280618 && g < 19290608):
            s = [19280618, 1347, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19290608 && g < 19300529):
            s = [19290608, 1348, 0, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1];
            break;
        case(g >= 19300529 && g < 19310518):
            s = [19300529, 1349, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0];
            break;
        case(g >= 19310518 && g < 19320506):
            s = [19310518, 1350, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0];
            break;
        case(g >= 19320506 && g < 19330425):
            s = [19320506, 1351, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0];
            break;
        case(g >= 19330425 && g < 19340414):
            s = [19330425, 1352, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 19340414 && g < 19350404):
            s = [19340414, 1353, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19350404 && g < 19360324):
            s = [19350404, 1354, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1];
            break;
        case(g >= 19360324 && g < 19370313):
            s = [19360324, 1355, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0];
            break;
        case(g >= 19370313 && g < 19380303):
            s = [19370313, 1356, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 1];
            break;
        case(g >= 19380303 && g < 19390220):
            s = [19380303, 1357, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 19390220 && g < 19400209):
            s = [19390220, 1358, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1];
            break;
        case(g >= 19400209 && g < 19410128):
            s = [19400209, 1359, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19410128 && g < 19420117):
            s = [19410128, 1360, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 19420117 && g < 19430107):
            s = [19420117, 1361, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19430107 && g < 19431228):
            s = [19430107, 1362, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 19431228 && g < 19441216):
            s = [19431228, 1363, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 19441216 && g < 19451205):
            s = [19441216, 1364, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19451205 && g < 19461124):
            s = [19451205, 1365, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19461124 && g < 19471113):
            s = [19461124, 1366, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 19471113 && g < 19481102):
            s = [19471113, 1367, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1];
            break;
        case(g >= 19481102 && g < 19491022):
            s = [19481102, 1368, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 19491022 && g < 19501012):
            s = [19491022, 1369, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19501012 && g < 19511002):
            s = [19501012, 1370, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 19511002 && g < 19520920):
            s = [19511002, 1371, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 19520920 && g < 19530909):
            s = [19520920, 1372, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19530909 && g < 19540829):
            s = [19530909, 1373, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1];
            break;
        case(g >= 19540829 && g < 19550818):
            s = [19540829, 1374, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0];
            break;
        case(g >= 19550818 && g < 19560807):
            s = [19550818, 1375, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0];
            break;
        case(g >= 19560807 && g < 19570728):
            s = [19560807, 1376, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1];
            break;
        case(g >= 19570728 && g < 19580717):
            s = [19570728, 1377, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0];
            break;
        case(g >= 19580717 && g < 19590707):
            s = [19580717, 1378, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 19590707 && g < 19600625):
            s = [19590707, 1379, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 19600625 && g < 19610614):
            s = [19600625, 1380, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19610614 && g < 19620603):
            s = [19610614, 1381, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0];
            break;
        case(g >= 19620603 && g < 19630524):
            s = [19620603, 1382, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0, 1];
            break;
        case(g >= 19630524 && g < 19640512):
            s = [19630524, 1383, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0];
            break;
        case(g >= 19640512 && g < 19650502):
            s = [19640512, 1384, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0];
            break;
        case(g >= 19650502 && g < 19660421):
            s = [19650502, 1385, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0];
            break;
        case(g >= 19660421 && g < 19670410):
            s = [19660421, 1386, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0];
            break;
        case(g >= 19670410 && g < 19680329):
            s = [19670410, 1387, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19680329 && g < 19690319):
            s = [19680329, 1388, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19690319 && g < 19700308):
            s = [19690319, 1389, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19700308 && g < 19710226):
            s = [19700308, 1390, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1];
            break;
        case(g >= 19710226 && g < 19720216):
            s = [19710226, 1391, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1];
            break;
        case(g >= 19720216 && g < 19730204):
            s = [19720216, 1392, 0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 19730204 && g < 19740124):
            s = [19730204, 1393, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1];
            break;
        case(g >= 19740124 && g < 19750113):
            s = [19740124, 1394, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19750113 && g < 19760102):
            s = [19750113, 1395, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 19760102 && g < 19761222):
            s = [19760102, 1396, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19761222 && g < 19771211):
            s = [19761222, 1397, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19771211 && g < 19781201):
            s = [19771211, 1398, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1];
            break;
        case(g >= 19781201 && g < 19791120):
            s = [19781201, 1399, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0];
            break;
        case(g >= 19791120 && g < 19801108):
            s = [19791120, 1400, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0];
            break;
        case(g >= 19801108 && g < 19811028):
            s = [19801108, 1401, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0];
            break;
        case(g >= 19811028 && g < 19821018):
            s = [19811028, 1402, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19821018 && g < 19831007):
            s = [19821018, 1403, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 19831007 && g < 19840926):
            s = [19831007, 1404, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 19840926 && g < 19850915):
            s = [19840926, 1405, 0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19850915 && g < 19860905):
            s = [19850915, 1406, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 19860905 && g < 19870825):
            s = [19860905, 1407, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];
            break;
        case(g >= 19870825 && g < 19880813):
            s = [19870825, 1408, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19880813 && g < 19890802):
            s = [19880813, 1409, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0];
            break;
        case(g >= 19890802 && g < 19900723):
            s = [19890802, 1410, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1];
            break;
        case(g >= 19900723 && g < 19910712):
            s = [19900723, 1411, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0];
            break;
        case(g >= 19910712 && g < 19920701):
            s = [19910712, 1412, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0];
            break;
        case(g >= 19920701 && g < 19930621):
            s = [19920701, 1413, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1];
            break;
        case(g >= 19930621 && g < 19940610):
            s = [19930621, 1414, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1];
            break;
        case(g >= 19940610 && g < 19950530):
            s = [19940610, 1415, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1];
            break;
        case(g >= 19950530 && g < 19960518):
            s = [19950530, 1416, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1];
            break;
        case(g >= 19960518 && g < 19970507):
            s = [19960518, 1417, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0];
            break;
        case(g >= 19970507 && g < 19980427):
            s = [19970507, 1418, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0];
            break;
        case(g >= 19980427 && g < 19990417):
            s = [19980427, 1419, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1];
            break;
    }
    return s;
}

function getGregorianYearArray(source_year) {
    var cases = {
        1420: [19990417, 0, 1, 0, 0, 1, 0, 1, 1, 1, 1, 0, 1],
        1421: [20000406, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1, 0, 1],
        1422: [20010326, 1, 0, 0, 1, 0, 0, 0, 1, 1, 1, 0, 1],
        1423: [20020315, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1424: [20030304, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1425: [20040221, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0],
        1426: [20050210, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1],
        1427: [20060131, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1428: [20070120, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 1, 1],
        1429: [20080110, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1],
        1430: [20081229, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1],
        1431: [20091218, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1],
        1432: [20101207, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0],
        1433: [20111126, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0],
        1434: [20121115, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 0],
        1435: [20131104, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1436: [20141025, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
        1437: [20151014, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1],
        1438: [20161002, 1, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 0],
        1439: [20170921, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1],
        1440: [20180911, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0],
        1441: [20190831, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0],
        1442: [20200820, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0],
        1443: [20210809, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1],
        1444: [20220730, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1],
        1445: [20230719, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1],
        1446: [20240707, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0],
        1447: [20250626, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0],
        1448: [20260616, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1],
        1449: [20270606, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1450: [20280525, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0],
        1451: [20290514, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1],
        1452: [20300504, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1453: [20310423, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1454: [20320411, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1],
        1455: [20330401, 0, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0],
        1456: [20340321, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1],
        1457: [20350311, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1],
        1458: [20360228, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1],
        1459: [20370216, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0],
        1460: [20380205, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1],
        1461: [20390126, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0],
        1462: [20400115, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1463: [20410104, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1464: [20411224, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1],
        1465: [20421214, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1, 1],
        1466: [20431203, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1467: [20441121, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1468: [20451110, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1],
        1469: [20461031, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0],
        1470: [20471020, 1, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1, 0],
        1471: [20481009, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1472: [20490928, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0],
        1473: [20500917, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1474: [20510906, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1],
        1475: [20520826, 0, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0],
        1476: [20530815, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1],
        1477: [20540805, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 0],
        1478: [20550725, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1],
        1479: [20560714, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1480: [20570703, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1481: [20580622, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0],
        1482: [20590611, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1],
        1483: [20600531, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0],
        1484: [20610520, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
        1485: [20620510, 0, 1, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1],
        1486: [20630430, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1],
        1487: [20640418, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1],
        1488: [20650407, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1489: [20660327, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 1],
        1490: [20670317, 0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1],
        1491: [20680305, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1],
        1492: [20690223, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1493: [20700212, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1],
        1494: [20710201, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1495: [20720121, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1496: [20730109, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1497: [20731230, 0, 1, 0, 1, 1, 1, 0, 0, 1, 0, 1, 0],
        1498: [20741219, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1],
        1499: [20751209, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0],
        1500: [20761127, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1],
        1300: [18821111, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0],
        1301: [18831031, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1],
        1302: [18841020, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1],
        1303: [18851009, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0],
        1304: [18860928, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0],
        1305: [18870918, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1],
        1306: [18880907, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1307: [18890827, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0],
        1308: [18900816, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1309: [18910805, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0],
        1310: [18920724, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0],
        1311: [18930714, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1],
        1312: [18940704, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0, 0],
        1313: [18950623, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1],
        1314: [18960612, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1315: [18970601, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1],
        1316: [18980521, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1317: [18990510, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1],
        1318: [19000430, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 0],
        1319: [19010419, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0],
        1320: [19020409, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1],
        1321: [19030330, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1],
        1322: [19040318, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1],
        1323: [19050307, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1324: [19060224, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0],
        1325: [19070213, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1],
        1326: [19080203, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1],
        1327: [19090123, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1],
        1328: [19100112, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1],
        1329: [19110101, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1330: [19111221, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1331: [19121209, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1332: [19131129, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0],
        1333: [19141118, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1],
        1334: [19151108, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0],
        1335: [19161027, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1],
        1336: [19171017, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1],
        1337: [19181006, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1338: [19190925, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0],
        1339: [19200913, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1],
        1340: [19210903, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0],
        1341: [19220823, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1342: [19230813, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0],
        1343: [19240801, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
        1344: [19250721, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0],
        1345: [19260710, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1],
        1346: [19270630, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0],
        1347: [19280618, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0],
        1348: [19290608, 0, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1],
        1349: [19300529, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0],
        1350: [19310518, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0],
        1351: [19320506, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0],
        1352: [19330425, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0],
        1353: [19340414, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0],
        1354: [19350404, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1],
        1355: [19360324, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0],
        1356: [19370313, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 1],
        1357: [19380303, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 1, 1],
        1358: [19390220, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 1],
        1359: [19400209, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 1],
        1360: [19410128, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0],
        1361: [19420117, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0],
        1362: [19430107, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1],
        1363: [19431228, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1364: [19441216, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1],
        1365: [19451205, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1],
        1366: [19461124, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0],
        1367: [19471113, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1],
        1368: [19481102, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0],
        1369: [19491022, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0],
        1370: [19501012, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1],
        1371: [19511002, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1],
        1372: [19520920, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1373: [19530909, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1],
        1374: [19540829, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0],
        1375: [19550818, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 1, 0],
        1376: [19560807, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1],
        1377: [19570728, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0],
        1378: [19580717, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1],
        1379: [19590707, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1],
        1380: [19600625, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
        1381: [19610614, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0],
        1382: [19620603, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0, 1],
        1383: [19630524, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0],
        1384: [19640512, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 1, 0],
        1385: [19650502, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1, 0],
        1386: [19660421, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0],
        1387: [19670410, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0],
        1388: [19680329, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
        1389: [19690319, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0],
        1390: [19700308, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1],
        1391: [19710226, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1],
        1392: [19720216, 0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1],
        1393: [19730204, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1],
        1394: [19740124, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1],
        1395: [19750113, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1396: [19760102, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1],
        1397: [19761222, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0],
        1398: [19771211, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1],
        1399: [19781201, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0],
        1400: [19791120, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0],
        1401: [19801108, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1, 0],
        1402: [19811028, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1403: [19821018, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0],
        1404: [19831007, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1],
        1405: [19840926, 0, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0],
        1406: [19850915, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 1],
        1407: [19860905, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
        1408: [19870825, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1409: [19880813, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0, 1, 0],
        1410: [19890802, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 0, 1],
        1411: [19900723, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0],
        1412: [19910712, 1, 0, 0, 1, 1, 0, 1, 1, 1, 0, 1, 0],
        1413: [19920701, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1],
        1414: [19930621, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 0, 1],
        1415: [19940610, 0, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1],
        1416: [19950530, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 1],
        1417: [19960518, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 0],
        1418: [19970507, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0],
        1419: [19980427, 0, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1]
    };
    if (cases[source_year]) {
        return cases[source_year];
    }
}

/* Functions  */
/*Examples:
 //document.querySelector('#RDate').val(getFormattedHijriDateFromArray(getHijriDate('now')));*/

/*get formated date*/
function rawToFormattedDate(rawDate) {
    rawDate = String(rawDate);
    return String(rawDate.substring(0, 4) + '/' + rawDate.substring(4, 6) + '/' + rawDate.substring(6, 8));
}

function addDays(rawDate, daysCount) {
    var sourceDate = new Date(rawToFormattedDate(rawDate));
    sourceDate.setDate(sourceDate.getDate() + daysCount);
    var year = sourceDate.getFullYear();
    var month = ((parseInt(sourceDate.getMonth() + 1, 10) < 10) ? ('0' + (parseInt(sourceDate.getMonth() + 1, 10))) : (parseInt(sourceDate.getMonth(), 10) + 1));
    var day = (sourceDate.getDate() < 10) ? ('0' + sourceDate.getDate()) : sourceDate.getDate();
    var d_day_no = sourceDate.getDay();
    return [String(year), String(month), String(day), d_day_no];
}

function getGregorianDate(rawHijriDate) {
    var selectedYearArray = getGregorianYearArray(rawHijriDate.substr(0, 4));
    var selectedMonth = parseInt(rawHijriDate.substr(4, 2), 10);
    var selectedDays = parseInt(rawHijriDate.substr(6, 2), 10);
    var totalDays = 0;
    for (var i = 1; i < selectedMonth; i++) {
        totalDays = selectedYearArray[i] == 1 ? totalDays += 30 : totalDays + 29;
    }
    var dateData = addDays(selectedYearArray[0], (totalDays + selectedDays - 1));
    var dayNo = dateData[3];
    var rawDate = dateData[0] + dateData[1] + dateData[2];
    return {
        rawDate: rawDate,
        dayNo: dayNo
    };
}

/*get the number of days in a hijri month*/
function getHijriMonthDaysCount(hijriYear, hijriMonth) {
    var selectedYear = getGregorianYearArray(hijriYear);
    return selectedYear[parseInt(hijriMonth, 10)] === 1 ? 30 : 29;
}


var d, g_date, d_day_no, g_date_diff;

/*get row hijri date like: 14350606 from date array*/
function getRawHijriDateFromArray(hijri) {
    var year = hijri[0];
    var month = (hijri[1] < 10) ? ('0' + hijri[1]) : hijri[1];
    var day = (hijri[2] < 10) ? ('0' + hijri[2]) : hijri[2];
    return String(year) + String(month) + String(day);
}


/*get deffrence between to grogorian days*/
var _MS_PER_DAY = 1000 * 60 * 60 * 24;

function dateDifferentInDays(a, b) {
    /*Discard the time and time-zone information.*/
    a = new Date(a);
    b = new Date(b);
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc1 - utc2) / _MS_PER_DAY);
}

/*after we get the wanted "selected_year",we do some calculation to get (year,month,day)*/
function calculate_hijri_days(hijri_array) {
    var total_h_days = 0;
    var h_year = hijri_array[1];
    var h_month = 0;
    var h_day = 0;
    for (var i = 2; i < 14; i++) {
        h_day = (g_date_diff + 1) - total_h_days;
        total_h_days = (hijri_array[i] == 1) ? total_h_days += 30 : total_h_days += 29;
        if (total_h_days > g_date_diff) {
            h_month = i - 1;
            break;
        }
    }
    return ([h_year, h_month, h_day, d_day_no]);
}

function getHijriDate(source_g_date = 'now') {
    if (source_g_date == 'now') {
        d = new Date();
    } else {
        d = new Date(rawToFormattedDate(source_g_date));
    }
    var year = d.getFullYear();
    var month = ((parseInt(d.getMonth() + 1, 10) < 10) ? ('0' + (parseInt(d.getMonth() + 1, 10))) : (parseInt(d.getMonth(), 10) + 1));
    var day = (d.getDate() < 10) ? ('0' + d.getDate()) : d.getDate();
    d_day_no = d.getDay();
    g_date = String(year) + String(month) + String(day);
    s = getHijriYearArray(g_date);
    g_date_diff = (dateDifferentInDays(rawToFormattedDate(g_date), rawToFormattedDate(s[0])));
    return calculate_hijri_days(s);
}

function date_to_no(formattedDate) {
    if (!formattedDate) return;
    if (typeof (formattedDate) != 'string') {
        console.log('تأكد من أن التاريخ المرسل أنه على شكل نصي');
        return;
    }
    var re = new RegExp("/", 'g');
    return parseInt(formattedDate.replace(re, ''));
}

var dateInput = document.querySelector('input[zezo_date=true]');
if (dateInput !== null) {
    /* Render the Calender  */
    var monthsNames = ['محرم', 'صفر', 'ربيع الأول', 'ربيع الثاني', 'جمادى الأولى', 'جمادى الثاني', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'];
    var weekDayShort = ['أحد', 'اثن', 'ثلا', 'أرب', 'خم', 'جم', 'سبت'];
    var weekDayName = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

    var date_array;

    var text_id_name;
    /*if you change the class name,then you should change it in the css file.*/
    var main_class_name = '.zezo_date.picker__box';
    var main_class_name_no_dot = 'zezo_date picker__box';
    var text_position;
    /*get today hijri date and store it
     default date is the date that was in the text field and the chosen date*/
    var z_default_year;
    var z_default_month;
    var z_default_day;

    var hijri_date = getRawHijriDateFromArray(getHijriDate('now'));
    var day_no = getGregorianDate(getRawHijriDateFromArray(getHijriDate('now'))).dayNo;

    var today_day = hijri_date.substring(6, 8);
    var today_month = hijri_date.substring(4, 6);
    var today_year = hijri_date.substring(0, 4);
    /*make the UI only one time*/
    make_ui();
    /*create event handlers*/
    load_click_events();
    /*make text field read only*/
    // var dateInput = document.querySelector('input[zezo_date=true]');

    // dateInput.setAttribute('readonly', 'readonly');
    /*if the user clicked another fields*/
    var notDateInput = document.querySelectorAll('input:not([zezo_date=true])');
    if (notDateInput !== null) {
        for (var i = 0; i < notDateInput.length; i++) {
            notDateInput[i].onfocus = function () {
                z_hide();
            };
        }
    }
    /*trigger focus event for only the zezo_date fields*/
    dateInputAll = document.querySelectorAll('input[zezo_date=true]');
    for (var i = 0; i < dateInputAll.length; i++) {
        dateInputAll[i].setAttribute('readonly', 'readonly');
        dateInputAll[i].addEventListener('focus', function () {
            openCal(this);
        });
    }


    function openCal($text_field) {
        /*get the date from the text field*/
        if ($text_field.value.length > 0) {
            /*store the date that was in the text field*/
            date_array = $text_field.value;
            date_array = date_array.split('/');
            z_default_year = (date_array[0]);
            z_default_month = (date_array[1]);
            z_default_day = (date_array[2]);
        } else {
            /*get today date*/
            z_default_day = today_day;
            z_default_month = today_month;
            z_default_year = today_year;
        }
        /*store focused text field id and positoin,so they will be used later*/
        text_id_name = ($text_field.id);
        text_position = $text_field.getBoundingClientRect();
        document.querySelector('.picker__day-display').innerHTML = (z_default_day);
        show_cal();
    }

    function z_hide() {
        document.querySelector('.picker').classList.remove('picker--focused');
        document.querySelector('.picker').classList.remove('picker--opened');
    }

    function load_days() {
        var mm, yyyy, yyyymmdd;
        mm = ((z_default_month < 10) ? '0' + parseInt(z_default_month, 10) : z_default_month);
        yyyy = z_default_year;
        yyyymmdd = String(yyyy) + String(mm) + '01';
        var first_day_no = getGregorianDate(yyyymmdd).dayNo;
        var month_days = getHijriMonthDaysCount(z_default_year, z_default_month);

        var day_divs = document.querySelectorAll(main_class_name + ' .d');

        for (var i = 0; i < day_divs.length; i++) {
            day_divs[i].innerHTML = ('');
            day_divs[i].classList.remove('picker__day--outfocus');
            day_divs[i].classList.remove('picker__day--infocus');
            day_divs[i].classList.remove('picker__day--selected');
            day_divs[i].classList.remove('picker__day--weekend');
            day_divs[i].classList.remove('picker__day--today');
            day_divs[i].removeAttribute('id');
        }

        var corrected_day;
        for (var i1 = 1; i1 < 43; i1++) {
            var dayBlock = document.querySelector('.d_' + i1);
            corrected_day = (i1 - parseInt(first_day_no, 10));
            if (i1 > first_day_no && corrected_day <= month_days) {
                dayBlock.innerHTML = (corrected_day);
                dayBlock.setAttribute('id', 'd_' + corrected_day);
                dayBlock.className += (' picker__day--infocus ');
            } else {
                dayBlock.className += (' picker__day--outfocus ');
            }
            /*weekends*/
            if ((i1 + 1) % 7 === 0 || i1 % 7 === 0) {
                dayBlock.className += (' picker__day--weekend ');
            }
        }
        var first_year = z_default_year - 32;
        for (var i8 = 1; i8 < 37; i8++) {
            document.querySelector(main_class_name + ' .choose_y[y_order="' + parseInt(i8, 10) + '"]').innerHTML = (first_year);
            document.querySelector(main_class_name + ' .choose_y[y_order="' + parseInt(i8, 10) + '"]').setAttribute('year_no', first_year);
            first_year++;
        }

        var month_divs = document.querySelectorAll(main_class_name + ' .choose_m');

        for (var i = 0; i < month_divs.length; i++) {
            month_divs[i].classList.remove('today');
            month_divs[i].classList.remove('picker__day--selected');
        }
        // document.querySelector(main_class_name + ' .choose_m').classList.remove('today');
        // document.querySelector(main_class_name + ' .choose_m').classList.remove('picker__day--selected');
        var year_divs = document.querySelectorAll(main_class_name + ' .choose_y');

        for (var i = 0; i < year_divs.length; i++) {
            year_divs[i].classList.remove('picker__day--selected');
            year_divs[i].classList.remove('today');
        }
        // document.querySelector(main_class_name + ' .choose_y').classList.remove('picker__day--selected');
        // document.querySelector(main_class_name + ' .choose_y').classList.remove('today');

        document.querySelector(main_class_name + ' .choose_y[y_order="33"]').className += (' picker__day--selected ');

        var today_year_div = document.querySelector(main_class_name + ' .choose_y[year_no="' + today_year + '"]');
        if (today_year_div) {
            today_year_div.className += (' today ');
        }

        if (parseInt(today_year, 10) == parseInt(z_default_year, 10)) {

            /*if the selected month equal today month then >>>*/
            if (parseInt(today_month, 10) == parseInt(z_default_month, 10)) {
                document.querySelector(main_class_name + ' #d_' + parseInt(today_day, 10)).className += (' picker__day--today ');
            }

            document.querySelector(main_class_name + ' .choose_m[m_no="' + parseInt(today_month, 10) + '"]').className += (' today  ');
        }
        document.querySelector(main_class_name + ' .d').classList.remove('picker__day--selected');
        document.querySelector(main_class_name + ' .choose_m').classList.remove('picker__day--selected');
        document.querySelector(main_class_name + ' #d_' + parseInt(z_default_day, 10)).className += (' picker__day--selected ');
        document.querySelector(main_class_name + ' .choose_m[m_no="' + parseInt(z_default_month, 10) + '"]').className += (' picker__day--selected ');

        document.querySelector(main_class_name + ' .picker__month-display').setAttribute('id', 'm_' + parseInt(z_default_month, 10));
        document.querySelector(main_class_name + ' .picker__month-display').innerHTML = (monthsNames[parseInt(z_default_month, 10) - 1]);

        // document.querySelector(main_class_name + ' .picker__year-display').innerHTML = (z_default_year + '<img src="/image/cal_down.png">');
        document.querySelector(main_class_name + ' .picker__year-display').innerHTML = (z_default_year + '<i class="zezo-icon-material-down"></i>');

    }

    /*create divs and numbers*/
    function make_ui() {
        document.querySelector("body").innerHTML += ('' +
            '<div class="picker">' +
            '<div class="picker__holder">' +
            '<div class="picker__frame">' +
            '<div class="picker__wrap">' +
            '<div class="' + main_class_name_no_dot + '">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>');
        /*Years*/
        document.querySelector(main_class_name).innerHTML += ('<div class="picker__date-display"></div>');
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<div class="picker__weekday-display">' + weekDayName[day_no] + '</div>');
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<div class="picker__month-display"></div>');
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<div class="picker__day-display">' + today_day + '</div>');
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<div class="picker__year-display"></div>');

        // document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<span class="top_icon" id="z_previous"><i class="material-icons white-text">keyboard_arrow_right</i></span>');
        // document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<span class="top_icon" id="z_previous"><img src="/image/cal_right.png"></span>');
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<span class="top_icon" id="z_previous"><i class="zezo-icon-material-right"></i></span>');

        // document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<span class="top_icon" id="z_next"><img src="/image/cal_left.png"></span>');
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<span class="top_icon" id="z_next"><i class="zezo-icon-material-left"></i></span>');
        // document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<span class="top_icon" id="z_next"><i class="material-icons white-text">keyboard_arrow_left</i></span>');

        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<div class="year_slider"></div>');
        document.querySelector(main_class_name + " .year_slider").style.display = 'none';
        document.querySelector(main_class_name + " .year_slider").innerHTML += ('<table class="picker__table"><tbody></tbody></table>');
        for (var i7 = 1; i7 < 13; i7++) {
            document.querySelector(main_class_name + " .year_slider table.picker__table tbody").innerHTML += ('<tr>' +
                '<td><div class="choose_y " y_order="' + i7 + '"></div></td>' +
                '<td><div class="choose_y " y_order="' + (i7 + 12) + '"></div></td>' +
                '<td><div class="choose_y " y_order="' + (i7 + 24) + '"></div></td>' +
                '</tr>');
        }
        document.querySelector("[y_order='1']").innerHTML = ('سنوات سابقة');
        /*months slider*/
        document.querySelector(main_class_name + " .picker__date-display").innerHTML += ('<div class="month_slider"></div>');

        document.querySelector(main_class_name + " .month_slider").style.display = 'none';
        document.querySelector(main_class_name + " .month_slider").innerHTML += ('<table class="picker__table"><tbody></tbody></table>');
        for (var i6 = 1; i6 < 7; i6++) {
            document.querySelector(main_class_name + " .month_slider table.picker__table tbody").innerHTML += ('<tr>' +
                '<td><div class="choose_m " m_no="' + i6 + '">' + '(' + i6 + ') ' + monthsNames[i6 - 1] + '</div></td>' +
                '<td><div class="choose_m " m_no="' + (i6 + 6) + '">' + '(' + (i6 + 6) + ') ' + monthsNames[(i6 - 1) + 6] + '</div></td>' +
                '</tr>');
        }

        /*Days (only the div container) */
        document.querySelector(main_class_name).innerHTML += ('<div class="picker__calendar-container"></div>');
        document.querySelector('.picker__calendar-container').innerHTML += ('<div class="z_day_names"></div>');
        document.querySelector('.picker__calendar-container').innerHTML += ('<table class="picker__table"></table>');
        document.querySelector('.picker__calendar-container').innerHTML += ('<div class="z_day_no"></div>');
        document.querySelector(main_class_name).innerHTML += ('<div class="picker__footer"></div>');

        document.querySelector(main_class_name + " .picker__footer").innerHTML += ('<button class="btn-flat picker__close">إغلاق</button>');

        document.querySelector(main_class_name + " .picker__footer").innerHTML += ('<button class="btn-flat picker__clear">مسح</button>');

        document.querySelector(main_class_name + " .picker__footer").innerHTML += ('<button class="btn-flat picker__today">اليوم</button>');

        var temp_table = '<thead><tr>';

        var chunk = 7;
        // document.querySelector(main_class_name + " .picker__calendar-container .picker__table").innerHTML += ('<thead><tr>');

        for (var w = 0; w < chunk; w++) {
            temp_table += ('<th class="picker__weekday" title="' + weekDayName[w] + '">' + weekDayShort[w] + '</th>');
        }
        temp_table += ('</tr></thead>');

        temp_table += ('<tbody>');
        for (var j1 = 1; j1 < 43; j1 += chunk) {
            temp_table += ('<tr>');
            for (var i1 = j1; i1 < j1 + chunk; i1++) {
                temp_table += ('<td><div class="picker__day d d_' + i1 + '"></div></td>');
            }
            temp_table += ('</tr>');
        }
        temp_table += ('</tbody>');
        document.querySelector(main_class_name + " .picker__calendar-container .picker__table").innerHTML += temp_table;
    }

    /*show zezo calender*/
    function show_cal() {
        document.querySelector('.picker').className += (' picker--opened picker--focused ');
        document.querySelector(main_class_name).style.display = 'block';

        load_days();

        // document.querySelector(main_class_name).style.display='block';
        set_weekday_class(day_no);
    }

    /*call this every time a calender is shown*/
    function load_click_events() {
        document.querySelector('#z_previous').onclick = (function () {
            change_month(-1);
        });
        document.querySelector('#z_next').onclick = (function () {
            change_month(1);
        });
        /***********************************************/

        /*day click function*/
        function day_click(day_no) {
            document.querySelector(main_class_name + ' .d').classList.remove('picker__day--selected');
            document.getElementById(day_no.id).className += (' picker__day--selected ');
            z_default_day = document.getElementById(day_no.id).innerHTML;

            z_show_full_date();
        }

        /*Day click*/
        var day_divs = document.querySelectorAll(main_class_name + ' .d');

        for (var i = 0; i < day_divs.length; i++) {

            day_divs[i].addEventListener('click', function () {
                day_click(this);
                z_hide();
                load_days();
            }, false);

            /*Day double click*/
            day_divs[i].addEventListener('dblclick', function () {
                day_click(this);
                z_hide();
            }, false);
        }

        document.querySelector('.picker').onclick = (function () {
            z_hide();
        });

        /*background picker*/
        document.querySelector('.picker__box').onclick = (function (event) {
            event.stopPropagation();
        });


        /************************************************/
        function change_month(number) {
            document.querySelector('.month_slider').style.display = 'none';
            z_default_month = parseInt(z_default_month, 10) + parseInt(number, 10);
            if (z_default_month == 13) {
                z_default_month = 1;
                z_default_year++;
            }
            if (z_default_month === 0) {
                z_default_month = 12;
                z_default_year--;
            }
            document.querySelector(main_class_name + ' .picker__month-display').innerHTML = (monthsNames[parseInt(z_default_month, 10) - 1]);
            // document.querySelector(main_class_name + ' .picker__year-display').innerHTML = (z_default_year + '<img src="/image/cal_down.png">');
            document.querySelector(main_class_name + ' .picker__year-display').innerHTML = (z_default_year + '<i class="zezo-icon-material-down"></i>');
            load_days();
            remove_selected_day_class();
        }

        var month_divs = document.querySelectorAll(main_class_name + ' .choose_m');
        for (var i = 0; i < month_divs.length; i++) {
            month_divs[i].addEventListener('click', function () {
                z_default_month = parseInt(this.getAttribute('m_no'), 10);
                document.querySelector(main_class_name + ' .picker__month-display').innerHTML = (monthsNames[z_default_month]);
                document.querySelector(main_class_name + ' .month_slider').style.display = 'none';
                load_days();
                remove_selected_day_class();
            }, false);
        }

        var year_divs = document.querySelectorAll(main_class_name + ' .choose_y');
        for (var i = 0; i < year_divs.length; i++) {
            year_divs[i].addEventListener('click', function () {
                z_default_year = this.innerHTML;
                // document.querySelector(main_class_name + ' .picker__year-display').innerHTML = (z_default_year + '<img src="/image/cal_down.png">');
                document.querySelector(main_class_name + ' .picker__year-display').innerHTML = (z_default_year + '<i class="zezo-icon-material-down"></i>');
                document.querySelector(main_class_name + ' .year_slider').style.display = 'none';
                load_days();
                remove_selected_day_class();
            }, false);
        }

        function remove_selected_day_class() {
            document.querySelector('.picker__day').classList.remove('picker__day--selected');
            document.querySelector('.picker__weekday-display').classList.remove('lighten-1');
            document.querySelector('.picker__weekday-display').classList.remove('red');
        }

        document.querySelector('.picker__year-display').onclick = function () {
            document.querySelector('.month_slider').style.display = 'none';
            var div = document.querySelector('.year_slider');
            if (div.style.display !== 'none') {
                div.style.display = 'none';
            } else {
                div.style.display = 'block';
            }
        };

        document.querySelector('.picker__month-display').onclick = function () {
            document.querySelector('.year_slider').style.display = 'none';
            var div = document.querySelector('.month_slider');
            if (div.style.display !== 'none') {
                div.style.display = 'none';
            } else {
                div.style.display = 'block';
            }
        };

        /***********************************************/
        /* OK click*/
        document.querySelector(main_class_name + ' .picker__close').onclick = function () {
            z_hide();
        };
        /*set today date*/
        document.querySelector(main_class_name + ' .picker__today').onclick = function () {
            hijri_date = getRawHijriDateFromArray(getHijriDate('now'));

            today_day = hijri_date.substring(6, 8);
            today_month = hijri_date.substring(4, 6);
            today_year = hijri_date.substring(0, 4);

            z_default_day = today_day;
            z_default_month = today_month;
            z_default_year = today_year;

            date_array = Array;
            date_array[0] = today_year;
            date_array[1] = today_month;
            date_array[2] = today_day;

            z_show_full_date();
            load_days();
            z_hide();
        };

        /* Cancel click*/
        document.querySelector('.picker__close').onclick = function () {
            /*restore the previous date that was in the text field*/
            if (date_array) {
                if (date_array.length > 0) {
                    document.getElementById(text_id_name).value = (date_array[0] + '/' + date_array[1] + '/' + date_array[2]);
                }
            } else {
                document.getElementById(text_id_name).value = ('');
            }
            // z_show_full_date();
            z_hide();
        };

        /*Clear click*/
        document.querySelector('.picker__clear').onclick = function () {
            document.getElementById(text_id_name).value = ('');
            z_hide();
            document.getElementById(text_id_name).dispatchEvent(new Event('change'));
        };
        /***********************************************/
    }

    /*fill date in text box*/
    function z_show_full_date() {
        var dd, mm, yyyy, yyyymmdd;
        dd = ((z_default_day < 10) ? '0' + parseInt(z_default_day, 10) : z_default_day);
        mm = ((z_default_month < 10) ? '0' + parseInt(z_default_month, 10) : z_default_month);
        yyyy = z_default_year;
        yyyymmdd = String(yyyy) + String(mm) + String(dd);
        document.getElementById(text_id_name).value = (yyyy + '/' + mm + '/' + dd);
        var change_event = new Event('change');
        document.getElementById(text_id_name).dispatchEvent(change_event);
        document.querySelector('.picker__day-display').innerHTML = (z_default_day);
        day_no = getGregorianDate(yyyymmdd).dayNo;
        document.querySelector('.picker__weekday-display').innerHTML = (weekDayName[day_no]);
        set_weekday_class(day_no);
    }

    function set_weekday_class(day_no) {
        if (day_no > 4) {
            document.querySelector('.picker__weekday-display').className += (' red lighten-1 ');
        } else {
            document.querySelector('.picker__weekday-display').classList.remove('lighten-1');
            document.querySelector('.picker__weekday-display').classList.remove('red');
        }
    }
}
